import React from 'react';

import type { Maybe } from 'src/common/types/Maybe';

export type RefillRequestDetails = {
  needRefill: Maybe<boolean>;
  outOf: Maybe<string[]>;
  remainingBupeDoses: Maybe<string>;
  earlyRefillReason: Maybe<string>;
};

type RefillRequestProps = {
  bridgeSubmissionDetails: RefillRequestDetails;
};

export const RefillRequest = ({ bridgeSubmissionDetails }: RefillRequestProps) => {
  const { needRefill, outOf, remainingBupeDoses, earlyRefillReason } = bridgeSubmissionDetails;

  if (!needRefill) {
    return null;
  }

  const medicationList = outOf ?? [];
  const medicationText = medicationList.join(', ');

  const details = [
    medicationText && `Medications: ${medicationText}`,
    remainingBupeDoses && `Remaining days: ${remainingBupeDoses}`,
    earlyRefillReason && `Early refill reason: ${earlyRefillReason}`,
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <li>
      <span className="label">Needs refill:</span> {details || 'Yes'}
    </li>
  );
};
